/** Tempo de espera pela troca do Service Worker antes de recarregar a página de qualquer jeito. */
const RELOAD_FALLBACK_MS = 3000;

/**
 * Ativa a versão nova do Service Worker e recarrega a página.
 *
 * O aviso de troca de controle (controllerchange) nem sempre chega — por exemplo numa aba
 * que ficou aberta durante várias publicações seguidas —, então a versão em espera também é
 * ativada diretamente e a página é recarregada na troca ou, no máximo, após um prazo curto.
 *
 * @param {() => (Promise|void)} [activate] ativação específica do app (ex.: updateServiceWorker do vite-plugin-pwa)
 */
export function applyUpdate(activate) {
  let reloaded = false;
  const reload = () => {
    if (reloaded) return;
    reloaded = true;
    window.location.reload();
  };

  navigator.serviceWorker?.addEventListener('controllerchange', reload, { once: true });
  Promise.resolve()
    .then(() => activate?.())
    .catch(() => {})
    .then(() => navigator.serviceWorker?.getRegistration())
    .then((registration) => registration?.waiting?.postMessage({ type: 'SKIP_WAITING' }))
    .catch(() => {});
  setTimeout(reload, RELOAD_FALLBACK_MS);
}

export const UPDATE_CHECK_INTERVAL_MS = 30 * 60 * 1000;

/** Verifica nova versão periodicamente e sempre que o app volta a ficar visível. */
export function scheduleUpdateChecks(registration) {
  const check = () => {
    if (navigator.onLine) registration.update().catch(() => {});
  };
  setInterval(check, UPDATE_CHECK_INTERVAL_MS);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') check();
  });
}
